module.exports = __webpack_public_path__ + "static/media/img-background2.776aed9a.jpg";